import { Component, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-email-vew-with-copy',
  templateUrl: './email-vew-with-copy.component.html',
  styleUrls: ['./email-vew-with-copy.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush // Optimized performance
})
export class EmailVewWithCopyComponent {
  /** The actual text content to be copied */
  @Input() content: string = '';
  

  isLoading = false;
  isCopied = false;

  constructor(
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef
  ) {}

  async copyText() {
    if (!this.content) return;

    this.isLoading = true;
    
    try {
      // Use modern Native Clipboard API
      await navigator.clipboard.writeText(this.content);
      
      // Simulate a small delay if you want the spinner to be visible 
      // (optional, but good for UX if the copy is instant)
      await new Promise(resolve => setTimeout(resolve, 300));

      this.handleSuccess();
    } catch (err) {
      this.toastr.error('Failed to copy text', 'Error');
    } finally {
      this.isLoading = false;
      this.cdr.markForCheck();
    }
  }

  private handleSuccess() {
    this.isCopied = true;
    this.toastr.success('Copied to clipboard!', 'Success', {
      closeButton: false,
      positionClass: 'toast-bottom-right',
      timeOut: 2000
    });

    // Reset the checkmark back to "Copy" after 2 seconds
    setTimeout(() => {
      this.isCopied = false;
      this.cdr.markForCheck();
    }, 2000);
  }
}